var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var networksState = {
    data: null,
    error: null,
    loading: false
};
var lineItemState = {
    data: null,
    error: null,
    loading: false
};
var networkReducer = function (state, action) {
    if (state === void 0) { state = networksState; }
    switch (action.type) {
        case Types.GET_NETWORK_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_NETWORK_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_NETWORK_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_NETWORK_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var lineItemReducer = function (state, action) {
    if (state === void 0) { state = networksState; }
    switch (action.type) {
        case Types.GET_LINE_ITEM_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_LINE_ITEM_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_NETWORK_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_LINE_ITEM_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var GamReducer = {
    networkData: networkReducer,
    lineItemData: lineItemReducer
};
export var networkData = function (state) { return (state.networkData.data ? state.networkData.data : null); };
export var alertError = function (state) { return state.networkData.error; };
export var isLoadNetwork = function (state) { return state.networkData.loading; };
export var lineItemData = function (state) { return (state.lineItemData.data ? state.lineItemData.data : null); };
export var lineItemError = function (state) { return state.lineItemData.error; };
export var isLoadLineItem = function (state) { return state.lineItemData.loading; };
export default GamReducer;
